export const translationShortcuts = [
  'nudgeUp',
  'nudgeDown',
  'nudgeLeft',
  'nudgeRight',
  'nudgeInwards',
  'nudgeOutwards',
  'nudgeUpSlow',
  'nudgeDownSlow',
  'nudgeLeftSlow',
  'nudgeRightSlow',
  'nudgeInwardsSlow',
  'nudgeOutwardsSlow',
];

export const rotationShortcuts = [
  'yawLeft',
  'yawRight',
  'pitchLeft',
  'pitchRight',
  'rollLeft',
  'rollRight',
  'yawLeftSlow',
  'yawRightSlow',
  'pitchLeftSlow',
  'pitchRightSlow',
  'rollLeftSlow',
  'rollRightSlow',
];

export const resizeShortcuts = [
  'contractDown',
  'contractLeft',
  'contractHeight',
  'expandRight',
  'expandUp',
  'expandHeight',
  'contractDownSlow',
  'contractLeftSlow',
  'contractHeightSlow',
  'expandRightSlow',
  'expandUpSlow',
  'expandHeightSlow',
];

export type TranslationShortcut = (typeof translationShortcuts)[number];
export type ResizeShortcut = (typeof resizeShortcuts)[number];
export type RotationShortcut = (typeof rotationShortcuts)[number];
export type TransformShortcut =
  | RotationShortcut
  | TranslationShortcut
  | ResizeShortcut;
